import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Organization } from 'src/app/models/um/organization';
import { AnalyticsService } from 'src/app/services/administration/analytics.service';
import { CommonService } from 'src/app/services/common.service';

@Component({
  selector: 'app-publish-analytics',
  templateUrl: './publish-analytics.component.html',
  styleUrls: ['./publish-analytics.component.scss']
})
export class PublishAnalyticsComponent implements OnInit  {

  @Input() public Content: any;
  content: any;
  dashboardDetails: any;
  productGroup = "";
  ProgramData: Organization;
  constructor(public analyticsService: AnalyticsService, private commonservice: CommonService,
    public modalRef: NgbActiveModal,
  ) { }

  ngOnInit() {
    this.dashboardDetails = this.Content.DashboardDetail;
    this.ProgramDetails();
  }

  cancel() {
    this.modalRef.close();
  }

  ProgramDetails() {
    this.analyticsService.getData("api/Analytics/ProgramDetailsByOrganisationID").subscribe(result => {
      this.ProgramData = result.Data;
    })
  }

  shareDashboard() {

    var name = this.productGroup;
    if (name != "" && name != null) {
      // if (name == "GRT1" || name == "GRT2" || name == "GRT3")
      //   name = "GRT"

      this.dashboardDetails.ProductName = name;
      this.analyticsService.InsertDataPost("api/Analytics/ShareSSR", this.dashboardDetails).subscribe((response: any) => {
        if (response.Status != undefined && response.Status == 0) {
          // this.getDashboards();
          this.commonservice.SuccessBanner("Dashboard published successfully");
          this.cancel();
        } else {
          this.commonservice.ValidationBanner("Dashboard published un-successfull.");
        }
      });
    } else {
      this.commonservice.ValidationBanner("Please select at least one program.");
    }

  }

}
